<script setup lang="ts">
import { onMounted, toRefs,watch,reactive, ref } from "vue";
import { $vfm, VueFinalModal, ModalsContainer } from 'vue-final-modal';
import HelpAction from './HelpAction.vue';
import drag from '@branu-jp/v-drag';
import { uuid } from 'vue-uuid';

const props = defineProps({
    isVisible: {
      required: true,
      type: Boolean,
      default: false,
    },
    isLoading: {
      type:Boolean,
      default : () => {
        return false;
      }
    },
    isHideOverlay: {
      type:Boolean,
      default: () => {
        return false;
      }
    },
    isOverlayClose: {
      type:Boolean,
      default: () => {
        return true;
      }
    },
    isDraggable: {
      type:Boolean,
      default: () => {
        return false;
      }
    },
    isResizable: {
      type:Boolean,
      default: () => {
        return false;
      }
    },
    isJustFit: {
      type:Boolean,
      default: () => {
        return false;
      }
    },
    width:{
      type:String,
      default: () => {
        return '';
      }
    },
    align:{
      type:String,
      default: () => {
        return '';
      }
    },
    helpKey:{
      type:String,
      default: () => {
        return '';
      }
    },
    close: {
      type:Function,
    },
})

const dialogClose = () => {
  if (props.isLoading) {
    return;
  }
  if (typeof props.close !== 'undefined') {
    props.close();
  }
}

const outsideDialogClose = () => {
  if (props.isLoading) {
    return;
  }
  if (props.isOverlayClose == false) {
    return;
  }
  if (typeof props.close !== 'undefined') {
    props.close();
  }
}
</script>

<style scoped lang='sass'>
$mb: 767px
@mixin mobile 
  @media screen and (max-width:$mb)
    @content
:deep .modal-container
  display: flex
  justify-content: center
  align-items: center
:deep .modal-content
  position: relative
  display: flex
  flex-direction: column
  max-height: 90%
  margin: 0 1rem
  border: 1px solid #e2e8f0
  border-radius: 0.25rem
  background: #fff
  max-width:90%
  @include mobile
    min-width:90%
.modal__drag
  cursor: pointer
.modal__title
  padding: 0 1.2rem
  font-size: 1.1rem
  font-weight: 700
  line-height: 2.5rem
  background-color: rgb(245, 186, 35)
  color: white
.modal__content
  flex-grow: 1
  overflow-y: auto
  padding: 1rem
</style>

<template>
<div>
  <vue-final-modal
    v-model="isVisible"
    :name="uuid.v1()"
    classes="modal-container"
    content-class="modal-content"
    :hide-overlay="isHideOverlay"
    :drag="isDraggable"
    :resize="isResizable"
    :lock-scroll="!isHideOverlay"
    :click-to-close="false"
    :prevent-click="isHideOverlay"
    :resize-directions="['br']"
    :content-style="[(width.length > 0 ? 'width:' + width : '')]"
    drag-selector=".modal__title"
    @click-outside="outsideDialogClose"
  >
    <div :class="'modal__title' + (isDraggable ? ' modal__drag' : '')">
        <slot name="header"></slot>
        <div v-show="helpKey.length > 0" class="absolute top-2 right-10">
          <help-action
            :help-key="helpKey"
          ></help-action>
        </div>
        <a v-show="(typeof close !== 'undefined')" href="javascript:void(0)" class="absolute top-2 right-2 text-2xl leading-6 font-bold text-white bg-gray-700 rounded-full align-middle" @click="close"><i class="fa-regular fa-circle-xmark"></i></a>
    </div>
    <div class="modal__content" :style="isJustFit ? 'padding:0;' : ''">
      <div v-if="isLoading" class="loading-mask">
        <div class="loading-content">
          <span style="color: white"><img src="../../public/images/loading.gif"></span>
        </div>
      </div>
      <slot></slot>
    </div>
  </vue-final-modal>
</div>
</template>

